/**
 * Stable CSS class names for E2E — StorePickUp page.
 * Used by the test automation team as deterministic selectors.
 * Containers use `store-pick-up__<element>`; inputs and user-interactable
 * controls use `store-pick-up-input--<name>`.
 */
export const SPU = {
    page: 'store-pick-up-page',
    root: 'store-pick-up',

    loading: 'store-pick-up__loading',
    loadingProgress: 'store-pick-up__loading-progress',

    header: 'store-pick-up__header',
    breadcrumb: 'store-pick-up__breadcrumb',

    filters: 'store-pick-up__filters',
    filterStore: 'store-pick-up__filter-store',
    filterStatus: 'store-pick-up__filter-status',
    filterAction: 'store-pick-up__filter-action',
    inputStore: 'store-pick-up-input--store',
    inputStatus: 'store-pick-up-input--status',
    statusMenuItem: 'store-pick-up__status-menu-item',
    btnSearch: 'store-pick-up-input--button-search',

    grid: 'store-pick-up__grid',

    cellStoreCode: 'store-pick-up__cell-store-code',
    cellStoreName: 'store-pick-up__cell-store-name',
    cellStatus: 'store-pick-up__cell-status',
    inputStatusSwitch: 'store-pick-up-input--status-switch',
    cellAddress: 'store-pick-up__cell-address',
    cellAddressText: 'store-pick-up__cell-address-text',
    cellLocation: 'store-pick-up__cell-location',
    btnOpenLocation: 'store-pick-up-input--button-open-location',
    cellCapacity: 'store-pick-up__cell-capacity',
    cellRemainingCapacity: 'store-pick-up__cell-remaining-capacity',
    cellActions: 'store-pick-up__cell-actions',
    btnActionsMenu: 'store-pick-up-input--button-actions-menu',

    editDrawer: 'store-pick-up-edit-drawer',
    editDrawerHeader: 'store-pick-up-edit-drawer__header',
    editDrawerBody: 'store-pick-up-edit-drawer__body',
    editDrawerFooter: 'store-pick-up-edit-drawer__footer',
    inputCapacity: 'store-pick-up-edit-drawer-input--capacity',
    inputVisibility: 'store-pick-up-edit-drawer-input--visibility',
    btnSave: 'store-pick-up-edit-drawer-input--button-save',
    btnClose: 'store-pick-up-edit-drawer-input--button-close',
} as const;

export const spuCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

export interface StorePickUpRow {
    id: number | string;
    storeCode: string;
    name: string;
    visible: boolean;
    capacity: number | null;
    remainingCapacity: number | null;
    lattitude?: number;
    longitude?: number;
    address: string;
    storeCodeAndName: string;
}

export const mapStorePickupApiItem = (item: any): StorePickUpRow => ({
    id: item.storeId ?? '-',
    storeCode: item.storeCode || '-',
    name: item.storeName || '',
    visible: Boolean(item.isVisible),
    capacity: item.capacity ?? item.Capacity ?? null,
    remainingCapacity: item.remainingCapacity ?? item.RemainingCapacity ?? null,
    lattitude: item.lattitude,
    longitude: item.longitude,
    address: `${item.address || ''} , ${item.storeCountyName || ''} / ${item.storeCityName || ''}`,
    storeCodeAndName: `${item.storeCode || ''} - ${item.storeName || ''}`,
});
